import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { setTrackLink } from '@vfit/shared/data-access';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const tagging = getTagging('OTP', 'fixed', client);

  const { trackView } = useTracking({
    event: ['checkout_step1.2'],
    event_label: 'OTP',
    opts: tagging?.opts,
    cartProduct: tagging?.trackingProduct,
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackLink(trackView, 'OTP');
  setTrackView(trackView);

  return null;
};

const TaggingPaymentMethodWithoutRecurringCard = withAnimationDelay()(TaggingComponent);

export default TaggingPaymentMethodWithoutRecurringCard;
